import sheetdb from 'sheetdb-node';
import Loading from '../loading';
import { useState } from 'react';
import { Button, Col, Row, Container, Modal, 
    ModalHeader, 
    ModalBody, 
    ModalFooter, Form, FormGroup, Input, Label } from 'reactstrap';
import './location.css';
import map from './map.png';

const Location = () => {
    var config = {
        address: 'lmrht3p7ssu0r',
      };
      
      // Create new client
      var client = sheetdb(config);
      
      const [successDiag, setSuccessDialog] = useState(false);
      const [loading, setLoading] = useState(false);
      
      const [parentName, setParentName] = useState("")
      const [studentName, setStudentName] = useState("")
      const [number, setNumber] = useState("")
      const [email, setEmail] = useState("")
      
    
      const handleChange = (event) => {
        if(event.target.name == "parentName"){
          setParentName(event.target.value)
        }
        if(event.target.name == "email"){
          setEmail(event.target.value)
        }
        if(event.target.name == "parentPhone"){
          setNumber(event.target.value)
        }
        if(event.target.name == "studentName"){
          setStudentName(event.target.value)
        }
      }
    
      const handleSubmit = () => {
        try{
          setLoading(true)
          client.create({ 
            ParentName: parentName, 
            TeenName: studentName,
            TeenAge: 10,
            ParentEmail: email,
            ParentPhone: number
          }, "Students").then(()=>{
          toggle();
          setLoading(false)
          setSuccessDialog(true)
          })
        }
        catch(ex){
          setLoading(false)
          alert(ex.data)
        }
      }
    const [formToggle, setFormToggle] = useState(false)
    const toggle = () => setFormToggle(!formToggle);

    return(<>
    {loading == true ? <Loading/> : <span></span>}
<Modal style={{border:'none'}}  isOpen={successDiag} toggle={()=>{setSuccessDialog(false)}}>
        <ModalHeader className='text-center' style={{border:'none'}} toggle={()=>{setSuccessDialog(false)}}><h3 className='text-success'>Congratulations!</h3></ModalHeader>
        <ModalBody>
        <Container>
          <Row>
            <Col sm={12} lg={12} md={12}>

            </Col>
            <Col className='text-center mb-5' lg={12} md={12} sm={12}>
              Thanks for signing up! I will be reaching out through text shortly. Talk soon :)
            </Col>
          </Row>
        </Container>
        </ModalBody>
      </Modal>





             <Modal style={{border:'none'}}  isOpen={formToggle} toggle={toggle}>
        <ModalHeader style={{border:'none'}} toggle={toggle}>One Step Closer to a Productive Summer</ModalHeader>
        <ModalBody>
        <Form>
  <Row>
  <Col md={12}>
      <FormGroup>
        <Label for="parentName">
          Parent Name
        </Label>
        <Input
          onChange={handleChange}
          id="parentName"
          name="parentName"
          placeholder="Name of Parent"
          type="text"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="studentName">
        Student Name
        </Label>
        <Input
        onChange={handleChange}
          id="studentName"
          name="studentName"
          placeholder="Name of Student"
          type="text"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="email">
          Parent Email
        </Label>
        <Input
        onChange={handleChange}
          id="email"
          name="email"
          placeholder="Email of Parent"
          type="email"
        />
      </FormGroup>
    </Col>
    <Col md={12}>
      <FormGroup>
        <Label for="parentPhone">
        Parent Phone
        </Label>
        <Input
        onChange={handleChange}
          id="parentPhone"
          name="parentPhone"
          placeholder="Phone number of Parent"
          type="text"
        />
      </FormGroup>
    </Col>
  </Row>
  
  
  <Row>
    <Col md={6}>
      
    </Col>
    <Col md={4}>
      
    </Col>
    <Col md={2}>
      
    </Col>
  </Row>
</Form>
        </ModalBody>
        <ModalFooter style={{border:'none'}} >
          <Button color="primary" onClick={handleSubmit}>
            Sign Up
          </Button>
        </ModalFooter>
      </Modal>



     <Container>
        <Row className='text-center mb-5 mt-5'>
                <h1 className='text-primary' id='curriculum' style={{fontWeight:'bolder'}}>Where is the workshop?</h1>
            </Row>
        </Container>
    <Container className='mb-5'>
    <Row>
    <Col className='text-center' md={6} lg={6} sm={12}>
                <h3 className='locationHeading' >Have the workshop come to you!</h3>
                <p style={{fontSize:'18px'}}>Each workshop has 4 to 5 students at a time.</p>
                <p style={{fontSize:'18px'}}>A date and location is communicated considering whatever is 
                    most convenient for all parents and students of each batch.</p>
                    <p>Serving HOUSTON and surrounding areas</p>
                    <Button className='mb-5 mt-4' style={{fontWeight:'bold'}} onClick={toggle} color="warning">Enroll Now</Button>
            </Col>
            <Col className='d-flex justify-content-center' md={6} lg={6} sm={12}>
                <img className='map' width={'70%'} src={map} />
            </Col>
        </Row>
    </Container>
        
    </>)
}

export default Location;